import { useContext } from 'react';

import { SingleQuestionDetailsContext } from './single-question-details-provider';

function useSingleQuestionDetails() {
  const context = useContext(SingleQuestionDetailsContext);

  if (!context) {
    throw new Error('useSingleQuestionDetails must be used within a SingleQuestionDetailsProvider');
  }

  return context;
}

export { useSingleQuestionDetails };
